import { Routes } from '@angular/router';
import { AuthGuard } from 'app/guards/auth-guard';
import { RoleGuard } from 'app/guards/role-guard';

export const interviewerRoutes: Routes = [
  {
    path: 'dashboard',
    loadComponent: () =>
      import(
        '@pages/interviewer/interviewer-dashboard/interviewer-dashboard'
      ).then((m) => m.InterviewerDashboard),
    data: {
      isSidebar: 1,
      isHeader: 1,
    },
  },
  {
    path: 'project-management',
    loadComponent: () =>
      import('@pages/interviewer/project-management/project-management').then(
        (m) => m.ProjectManagement
      ),
    data: {
      isSidebar: 1,
      isHeader: 1,
    },
  },
];
